export const adminPermissions = [
    { label: 'User', key: 'kedo.user' },
    { label: 'Data field', key: 'kedo.defdossierdeffield' },
    { label: 'Display field', key: 'kedo.displayitem' },
    { label: 'Defdossier', key: 'kedo.defdossier' },
    { label: 'Notification', key: 'kedo.notification' },
    { label: 'Role', key: 'kedo.role' },
    { label: 'Locales', key: 'kedo.locale' },
    { label: 'Files', key: 'kedo.file' },
    { label: 'Module', key: 'kedo.module' },

    { label: 'Events', key: 'kedo.event' },
    { label: 'ERD', key: 'kedo.erd' },
    { label: 'Permissions', key: 'kedo.defdossierpermission' },
    { label: 'ERD', key: 'kedo.log' },
    { label: 'User Activity', key: 'kedo.useractivity' },
    { label: 'Blocks', key: 'kedo.mypageblocks' },
    { label: 'Kedocx', key: 'kedo.kedocx' },
    { label: 'Query Builder', key: 'kedo.querybuilder' },
    { label: 'Webhooks', key: 'kedo.webhooks' },
]
